export default __webpack_public_path__ + "static/media/Six.ba28a741.png";